function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
export function FormattedNumberInput(_ref) {
  let {
    onChange,
    thousandSeparator = ',',
    decimalSeparator = '.',
    ...props
  } = _ref;
  const [isFocused, setIsFocused] = useState(false);

  // Default decimalScale to 2 if not provided
  props.decimalScale = !('decimalScale' in props) ? 2 : props.decimalScale;
  props.decimalSeparator = props.decimalScale ? decimalSeparator : null;

  // If the input is focused, show the raw value, otherwise default to 0 if the value is undefined or null
  const value = isFocused ? props.value : Number.parseFloat(props.value || 0).toFixed(props.decimalScale);
  const {
    onlyPositiveNumbers,
    ...restOfProps
  } = props;
  const isAllowed = values => {
    if (onlyPositiveNumbers) {
      const {
        floatValue
      } = values;
      return floatValue >= 0 || floatValue === undefined;
    } else {
      return true;
    }
  };
  const onNumericInputChange = (obj, sourceInfo) => {
    if (obj.value === '') {
      obj.value = 0;
    }
    typeof onChange === 'function' && onChange({
      target: {
        name: props.name,
        value: obj.value
      },
      sourceInfo
    });
  };
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({}, restOfProps, {
    valueIsNumericString: true,
    fixedDecimalScale: true,
    value: value,
    onValueChange: onNumericInputChange,
    customInput: Form.Control,
    thousandSeparator: thousandSeparator,
    isAllowed: isAllowed,
    onFocus: () => {
      setIsFocused(true);
      props.onFocus && props.onFocus();
    },
    onBlur: () => {
      setIsFocused(false);
      props.onBlur && props.onBlur();
    }
  }));
}